import { Link } from 'react-router';
import { HorizontalContainer, VerticalContainer } from '@/components';
import { GreenDotIcon, RedDotIcon } from '@/components/Icons';
import type { TrainingProgramViewModel } from '@/features/profile/model/types';
import { R } from '@/features/profile/resources/ProfileResources.resx';

type TrainingProgramCardProps = {
    program: TrainingProgramViewModel;
};

export const TrainingProgramCard = ({ program }: TrainingProgramCardProps) => (
    <Link
        aria-label={R.TrainingProgram_Title}
        to={`/TrainingProgramDetails?userId=${program.UserId}`}
        className="h-full min-h-28 cursor-pointer rounded-2xl border border-(--color-border-muted) p-4 hover:bg-(--color-bg-subtle)"
    >
        <VerticalContainer spacing="sm">
            <HorizontalContainer
                spacing="xs"
                className="min-h-7 items-center text-sm"
            >
                {program.IsActive && <GreenDotIcon className="size-2" />}
                {!program.IsActive && <RedDotIcon className="size-2" />}
                <span>{program.StatusText}</span>
            </HorizontalContainer>

            <div className="font-bold text-(--color-text-heading)">
                {R.TrainingProgram_Title}
            </div>
            <div className="leading-normal text-(--color-text-secondary)">
                {R.TrainingProgram_ValidUntil}
                {program.ExpirationDateString}
            </div>

            {program.IsActive && (
                <div className="text-sm leading-normal text-(--color-text-secondary)">
                    {R.TrainingProgram_AutoRenewalDescription}
                </div>
            )}
        </VerticalContainer>
    </Link>
);
